export class Delegate {
    id = null;
    tenantId = null;
    userId = null;
    applicationUserGroups = [];
    dispatchCompanies = [];
}